import React from 'react';
import { Box } from 'rebass';
import ImageSlice from '.';

const getDesktopSize = length => {
  switch (length) {
    case 1:
      return 1;
    case 2:
      return 1 / 2;
    default:
      return 1 / 3;
  }
};

const ImageSliceGrid = props => {
  return (
    <Box display="flex" m={-2} flexWrap="wrap">
      {props.items.map(item => (
        <Box
          p={1}
          width={[1, getDesktopSize(props.items.length)]}
          key={item.source.url}
        >
          <ImageSlice {...item} />
        </Box>
      ))}
    </Box>
  );
};

export default ImageSliceGrid;
